import * as React from 'react';
import { connect } from 'react-redux';
import { IProductInfo, IState, IUserInfo } from '../CustomTypes';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
  BorderColor,
  BorderStyle,
  BorderWidth,
  classNames,
  Display,
  FontSize,
  FontWeight,
  Icon,
  IconColor,
  IconName,
  AlignItems,
  JustifyContent,
  Margin,
  Padding,
  Width,
  LineHeight,
} from '@snoam/pinata';

interface IShoppingBasketProps extends RouteComponentProps {
  productInfo: IProductInfo;
  userInfo: IUserInfo;
  error: boolean;
}

const styleClass = {
  contentWrapper: classNames(
    Display.FLEX,
    Width.W_FULL,
    FontSize.TEXT_SM,
    FontSize.MD_TEXT_BASE,
    FontWeight.FONT_BOLD,
    JustifyContent.LG_JUSTIFY_CENTER,
    Margin.ML_4,
    Margin.LG_ML_0,
  ),
  root: classNames(
    BorderWidth.BORDER_B_1,
    BorderColor.BORDER_NEUTRAL_3,
    Margin.MX_NEGATIVE_6,
    Margin.MD_MX_0,
    BorderStyle.BORDER_SOLID,
    Display.FLEX,
    Padding.PX_6,
    Padding.MD_PX_2,
    Padding.PY_4,
    Padding.MD_PT_8,
    Margin.MB_4,
    AlignItems.ITEMS_CENTER,
    LineHeight.LEADING_NONE,
  ),
};

export class ShoppingBasket extends React.Component<
  IShoppingBasketProps,
  { showBasket: boolean }
> {
  public static displayName = 'ShoppingBasket';

  constructor(props) {
    super(props);
    this.state = {
      showBasket: true,
    };
  }

  public componentDidMount(): void {
    this.showBasket();
  }

  public componentDidUpdate(
    prevProps: Readonly<IShoppingBasketProps>,
    prevState: Readonly<{ showBasket: boolean }>, // eslint-disable-line @typescript-eslint/no-unused-vars
  ): void {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.showBasket();
    }
  }

  public showBasket = () => {
    const { pathname } = this.props.location;
    if (
      this.props.error ||
      pathname.indexOf('/receipt') !== -1 ||
      pathname.indexOf('/duplicate') !== -1 ||
      pathname.indexOf('/upgrade') !== -1 ||
      pathname.includes('selectpaymentmethod') // Redundant at this step
    ) {
      this.setState({ showBasket: false });
    } else {
      this.setState({ showBasket: true });
    }
  };

  public render() {
    const { header, price } = this.props.productInfo;
    return (
      <>
        {this.state.showBasket && (
          <div className={styleClass.root}>
            <Icon
              name={IconName.SHOPPING_CART}
              color={IconColor.NEUTRAL_7}
              screenReaderText={'Handlekurv-ikon'}
            />
            <div className={styleClass.contentWrapper}>
              <span className={Margin.MR_2}>{header}</span>
              <span>kr {price},-</span>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter<any, any>(
  connect(
    (state: IState) =>
      ({
        productInfo: state.productInfo,
        userInfo: state.userInfo,
      }) as IShoppingBasketProps,
  )(ShoppingBasket),
);
